export default __webpack_public_path__ + "static/media/LotusAgro.23597ea6.png";